import { Link } from "react-router-dom";
import { MessageCircle, Wrench } from "lucide-react";
import { whatsappLink } from "@/content/site";

export default function MobileBar() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-[var(--line)] bg-[var(--ink)]/95 backdrop-blur-md" data-testid="mobile-cta-bar">
      <Link to="/request-a-repair" data-testid="mobile-bar-request" className="h-16 flex items-center justify-center gap-2 bg-[var(--red)] font-display font-extrabold uppercase tracking-[0.12em] text-sm">
        <Wrench className="h-4 w-4" aria-hidden /> Request a Repair
      </Link>
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp" className="h-16 flex items-center justify-center gap-2 font-display font-extrabold uppercase tracking-[0.12em] text-sm">
        <MessageCircle className="h-4 w-4 text-[var(--wa)]" aria-hidden /> WhatsApp Us
      </a>
    </div>
  );
}
